import React, {useEffect, useState, useRef} from 'react';
import axios from "axios";
import {Filters, Loading, Map} from "../../Components";
import './app.scss';

const App = () => {

    const filtersRef = useRef();
    const [places, setPlaces] = useState([]);
    const [filteredPlaces, setFilteredPlaces] = useState([]);
    // const [selectedPlace, setSelectedPlace] = useState(null);

    useEffect(() => {

        const fetchPlaces = async () => {
            const response = await axios.get(`data/places.json`);
            setPlaces(response.data);
            setFilteredPlaces(response.data);
        }

        fetchPlaces();

    }, []);

    const onSelectPlace = (place) => {
        // setSelectedPlace(place);
        setFilteredPlaces([place]);
        filtersRef.current.setPlace(place);
    }

    const onSubmitForm = (name, city) => {

        // if (selectedPlace !== null) {
        //     setFilteredPlaces(places.filter((place) => place.id === selectedPlace.id));
        //     return;
        // }

        let tempPlaces = [];

        if (name.trim() !== '' && city.trim() === '') {
            tempPlaces = places.filter((p) => p.name.trim().toLowerCase().indexOf(name.trim().toLowerCase()) > -1);
        } else if (name.trim() === '' && city.trim() !== '') {
            tempPlaces = places.filter((p) => p.city === city);
        } else if (name.trim() !== '' && city.trim() !== '') {
            tempPlaces = places.filter((p) => p.name.trim().toLowerCase().indexOf(name.trim().toLowerCase()) > -1 && p.city === city);
        } else {
            tempPlaces = places;
        }

        if (tempPlaces.length === 0) {
            alert('Brak wyników.');
            setFilteredPlaces(places);
            return;
        }

        setFilteredPlaces(tempPlaces);
    }

    if (places.length === 0 || filteredPlaces.length === 0) {
        return <Loading/>;
    } else {
        return (
            <div className={'app-page'}>
                <Filters ref={filtersRef}
                         places={filteredPlaces}
                         onSelectPlace={onSelectPlace}
                         onSubmitForm={onSubmitForm}/>
                <Map places={filteredPlaces} onSelectPlace={onSelectPlace}/>
            </div>
        );
    }

}

export default App;
